const selectors = {
  stickyProduct: '[data-sticky-product]',
  atcButton: '[data-add-to-cart-btn]',
  b2tButton: '[data-back-to-top-btn]',
  configureButton: '[data-configure-btn]',
  productMeta: '.product__meta',
};

const stickyProduct = document.querySelector(selectors.stickyProduct);
const atcButton = document.querySelector(selectors.atcButton);
const b2tButton = document.querySelector(selectors.b2tButton);
const fourthSection = document.querySelector('.product');
const sectionHeight = stickyProduct.getBoundingClientRect().height;
const productMeta = document.querySelector(selectors.productMeta);

const handleB2t = () => {
  if (!b2tButton) return;

  b2tButton.addEventListener('click', (e) => {
    e.preventDefault();

    window.scrollTo({
      top: productMeta ? productMeta.offsetTop : 0,
      left: 0,
      behavior: 'smooth',
    });
  });
};

const handleAtc = () => {
  if (!atcButton) return;

  atcButton.addEventListener('click', (e) => {
    e.preventDefault();

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });

    document.querySelector('[data-add-to-cart]').click();
  });
};

const stickyNav = function (entries) {
  const [entry] = entries;

  if (!entry.isIntersecting) stickyProduct.classList.add('is-visible');
  else stickyProduct.classList.remove('is-visible');
};

const headerObserver = new IntersectionObserver(stickyNav, {
  root: null,
  threshold: 0,
  rootMargin: `0px`,
});

headerObserver.observe(fourthSection);

handleAtc();
handleB2t();
